import {
  INPUT_TYPE_TEXT,
  INPUT_TYPE_TEXT_FIELD,
} from "constant/topic/topic.const";

export function optionalFieldsEditGet(formData: any): any {
  const optionalFields: any = {};
  let textContent = formData.textContent;
  textContent = textContent.replaceAll(" ", "");
  if ("textContent" in formData && "textTranslation" in formData) {
    optionalFields[INPUT_TYPE_TEXT] = {
      [INPUT_TYPE_TEXT_FIELD.CONTENT]: textContent,
      [INPUT_TYPE_TEXT_FIELD.TRANSLATION]: formData.textTranslation,
    };
  }

  return optionalFields;
}
